import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { Provider } from "react-redux";
import allReducer from "redux/Reducer";
import { createStore } from "redux";

import axiosSetup from "./axios/setup";
import { createBrowserHistory } from "history";

const store = createStore(allReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
const browserHistory = createBrowserHistory();

axiosSetup.setupInterceptors(browserHistory, store);
ReactDOM.render(
  <Provider store={store}>
    <App  history={browserHistory}/>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
